import { useSelector, useDispatch } from "react-redux";
import { Box, List } from "@mui/material";
import { ListRounded, Verified } from "@mui/icons-material";
import {
  updateActiveAdminDashboard,
  updateAdminActiveCelebList,
  sidebarClose,
} from "../../store/actions";
import { useEffect } from "react";
import SingleOption from "./SingleOption";

export default function AdminPanelSidebar({ currentScreenWidth }) {
  const dispatch = useDispatch();
  const adminPanelSidebar = useSelector((state) => state.adminPanelSidebar);

  useEffect(() => {
    if (currentScreenWidth < 768) {
      dispatch(sidebarClose());
    }
  }, [currentScreenWidth, dispatch]);

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: "1",
        top: "65px",
        left:
          currentScreenWidth > 768
            ? adminPanelSidebar
              ? "-250px"
              : "0"
            : adminPanelSidebar
            ? "0"
            : "-250px",
        width: "250px",
        height: "calc(100vh - 65px)",
        backgroundColor: "#ec004f",
        transition: "all 0.3s",
        overflow: "hidden",
        boxShadow: 4,
      }}
    >
      <List>
        <SingleOption
          title="Celebrities"
          icon={<Verified sx={{ color: "#fff" }} />}
          onClick={() => {
            currentScreenWidth < 768 && dispatch(sidebarClose());
            dispatch(updateActiveAdminDashboard("Verification"));
            dispatch(updateAdminActiveCelebList(""));
          }}
        />
      </List>
    </Box>
  );
}
